// src/utils/loadRemoteModule.js
export async function loadRemoteModule(scope, module) {
  await __webpack_init_sharing__('default');
  const container = window[scope];
  if (!container) throw new Error(`[MF] Remote ${scope} not found`);

  await container.init(__webpack_share_scopes__.default);
  const factory = await container.get(module);
  const Module = factory();
  return Module;
}
